module.exports = __webpack_public_path__ + "img/5-4.2bfd29e0.svg";